// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import {
// // // //     Paper,
// // // //     Typography,
// // // //     IconButton,
// // // //     Button,
// // // //     Divider,
// // // //     Box,
// // // // } from "@mui/material";
// // // // import CloseIcon from "@mui/icons-material/Close";
// // // // import { useNavigate } from "react-router-dom";
// // // // import axios from "axios";
// // // // import sound from "./alaram.mp3";
// // // // import { Link } from "react-router-dom";
// // // // const NotificationContext = () => {
// // // //     const navigate = useNavigate();
// // // //     const [notifications, setNotifications] = useState([]);
// // // //     const previousOrderIds = useRef([]); // 🔹 to track previously seen orders
// // // //     const notificationSound = new Audio(sound);
// // // //     const isMobile = window.innerWidth <= 768;
// // // //     // ✅ Fetch order & payment notifications
// // // //     const fetchNotifications = async () => {
// // // //         try {
// // // //             const vendorId = localStorage.getItem("vendorId");
// // // //             const token = localStorage.getItem("authToken");
// // // //             if (!vendorId || !token) return;

// // // //             const response = await axios.get(
// // // //                 `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// // // //                 {
// // // //                     headers: {
// // // //                         accept: "*/*",
// // // //                         Authorization: `Bearer ${token}`,
// // // //                     },
// // // //                 }
// // // //             );

// // // //             const orders = response.data || [];

// // // //             // ✅ Filter only "PENDING" orders and exclude "TABLE_DINE_IN"
// // // //             const filteredOrders = orders.filter(
// // // //                 (order) =>
// // // //                     order.status?.toUpperCase() === "PENDING" &&
// // // //                     order.orderType !== "TABLE_DINE_IN"
// // // //             );

// // // //             // ✅ Format filtered order notifications
// // // //             const formatted = filteredOrders.map((order) => ({
// // // //                 id: order.orderId,
// // // //                 message: `🧾 Order #${order.orderId} | Status: ${order.status}`,
// // // //                 details: `📅 ${order.date} 🕒 ${order.time}\n🍽️ Items: ${order.order?.map((item) => item.dishName).join(", ") || "No items"
// // // //                     }`,
// // // //                 path: "/foodordermanagment",
// // // //             }));

// // // //             // ✅ Detect NEW orders (play sound only for new pending ones)
// // // //             const currentOrderIds = formatted.map((o) => o.id);
// // // //             const newOrders = currentOrderIds.filter(
// // // //                 (id) => !previousOrderIds.current.includes(id)
// // // //             );

// // // //             if (newOrders.length > 0) {
// // // //                 notificationSound.play().catch((err) =>
// // // //                     console.warn("Sound playback blocked by browser:", err)
// // // //                 );
// // // //             }

// // // //             previousOrderIds.current = currentOrderIds; // update for next check

// // // //             // ✅ Add optional static notifications
// // // //             const staticNotifications = [
// // // //                 { id: 1001, message: "⚠️ Subscription expiring soon!", path: "/subscriptionrenewal" },
// // // //                 { id: 1002, message: "🎊 Diwali special offers available!", path: "/offers" },
// // // //                 { id: 1003, message: "💰 New payment received today.", path: "/payment" },
// // // //             ];

// // // //             setNotifications([...formatted, ...staticNotifications]);
// // // //         } catch (error) {
// // // //             console.error("Error fetching notifications:", error);

// // // //             // fallback notifications
// // // //             setNotifications([
// // // //                 { id: 1, message: "🎉 Welcome to MAAMAA'S!", path: "/welcome" },
// // // //                 { id: 2, message: "✅ No new pending orders found.", path: "/orders" },
// // // //             ]);
// // // //         }
// // // //     };

// // // //     useEffect(() => {
// // // //         fetchNotifications();
// // // //         const interval = setInterval(fetchNotifications, 60000); // refresh every 1 minute
// // // //         return () => clearInterval(interval);
// // // //     }, []);

// // // //     const handleNotificationClick = (path) => navigate(path);

// // // //     const handleCloseNotification = (id) => {
// // // //         setNotifications((prev) => prev.filter((note) => note.id !== id));
// // // //     };

// // // //     if (notifications.length === 0) return null;

// // // //     return (
// // // //         <div>
// // // //             <p
// // // //                 className="breadcrumb maamaas-home-bredcum"
// // // //                 style={{
// // // //                     position: "fixed",
// // // //                     top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
// // // //                     left: "2vw",
// // // //                     width: "100%",
// // // //                     backgroundColor: "#fff",
// // // //                     zIndex: 1000,
// // // //                     padding: "10px 0",
// // // //                     fontSize: isMobile ? "16px" : "18px",
// // // //                     fontWeight: isMobile ? "normal" : "bold",
// // // //                     textAlign: "center",
// // // //                     margin: 0,
// // // //                 }}
// // // //             >

// // // //                 <Link
// // // //                     to="/foodladingpage"
// // // //                     style={{
// // // //                         color: "purple",
// // // //                         fontWeight: "bold",
// // // //                         textDecoration: "none",
// // // //                     }}
// // // //                 >
// // // //                     Food & Beverages

// // // //                 </Link>

// // // //                 <span className="separator"> &gt; </span>
// // // //                 <Link

// // // //                     style={{
// // // //                         color: "purple",
// // // //                         fontWeight: "bold",
// // // //                         textDecoration: "none",
// // // //                     }}
// // // //                 >
// // // //                     Notifications
// // // //                 </Link>
// // // //             </p>

// // // //             <Box
// // // //                 sx={{
// // // //                     position: "fixed",
// // // //                     top: 0,
// // // //                     left: 0,
// // // //                     width: "100vw",
// // // //                     height: "100vh",
// // // //                     zIndex: 3000,
// // // //                     display: "flex",
// // // //                     justifyContent: "center",
// // // //                     alignItems: "center",
// // // //                     backgroundColor: "transparent",
// // // //                     pointerEvents: "none", // ✅ allow clicks to pass through background  
// // // //                     scrollbarWidth: "none",
// // // //                 }}
// // // //             >
// // // //                 <Box
// // // //                     sx={{
// // // //                         width: "80%",
// // // //                         maxWidth: "900px",
// // // //                         scrollbarWidth: "none",
// // // //                         height: "80vh",
// // // //                         overflowY: "auto",
// // // //                         display: "flex",
// // // //                         flexDirection: "column",
// // // //                         alignItems: "center",
// // // //                         gap: 3,
// // // //                         padding: "20px",
// // // //                         borderRadius: "12px",
// // // //                         marginTop: "110px",
// // // //                         pointerEvents: "auto", // ✅ keep notification cards clickable
// // // //                     }}
// // // //                 >
// // // //                     {notifications.map((note, index) => (
// // // //                         <Paper
// // // //                             key={note.id}
// // // //                             elevation={8}
// // // //                             sx={{
// // // //                                 width: "100%",
// // // //                                 padding: "24px",
// // // //                                 borderRadius: "14px",
// // // //                                 borderLeft: "8px solid #7B2CBF",
// // // //                                 backgroundColor: "#ffffff",
// // // //                                 boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
// // // //                                 animation: `slideUp 0.5s ease ${index * 0.15}s`,
// // // //                                 position: "relative",
// // // //                                 transition: "transform 0.3s ease",
// // // //                                 "&:hover": { transform: "scale(1.02)" },
// // // //                             }}
// // // //                         >
// // // //                             <IconButton
// // // //                                 size="small"
// // // //                                 onClick={() => handleCloseNotification(note.id)}
// // // //                                 sx={{
// // // //                                     position: "absolute",
// // // //                                     top: 12,
// // // //                                     right: 12,
// // // //                                     color: "#777",
// // // //                                     "&:hover": { color: "#000" },
// // // //                                 }}
// // // //                             >
// // // //                                 <CloseIcon fontSize="small" />
// // // //                             </IconButton>

// // // //                             <Typography
// // // //                                 variant="h6"
// // // //                                 sx={{
// // // //                                     fontWeight: "bold",
// // // //                                     color: "#4B0082",
// // // //                                     marginBottom: "8px",
// // // //                                 }}
// // // //                             >
// // // //                                 Notification
// // // //                             </Typography>

// // // //                             <Divider sx={{ marginBottom: "14px" }} />

// // // //                             <Typography
// // // //                                 variant="body1"
// // // //                                 sx={{
// // // //                                     color: "#333",
// // // //                                     marginBottom: "16px",
// // // //                                     lineHeight: 1.6,
// // // //                                     fontSize: "16px",
// // // //                                     whiteSpace: "pre-line",
// // // //                                 }}
// // // //                             >
// // // //                                 {note.message}
// // // //                                 {note.details ? `\n\n${note.details}` : ""}
// // // //                             </Typography>

// // // //                             <Button
// // // //                                 variant="contained"
// // // //                                 onClick={() => handleNotificationClick(note.path)}
// // // //                                 sx={{
// // // //                                     background: "linear-gradient(90deg, #7B2CBF, #9D4EDD)",
// // // //                                     textTransform: "none",
// // // //                                     fontWeight: 600,
// // // //                                     borderRadius: "10px",
// // // //                                     padding: "8px 18px",
// // // //                                     "&:hover": {
// // // //                                         background: "linear-gradient(90deg, #6A1FBF, #8A2BE2)",
// // // //                                     },
// // // //                                 }}
// // // //                             >
// // // //                                 View
// // // //                             </Button>
// // // //                         </Paper>
// // // //                     ))}
// // // //                 </Box>

// // // //                 {/* Animations & scrollbar style */}
// // // //                 <style>
// // // //                     {`
// // // //                     @keyframes slideUp {
// // // //                         from { transform: translateY(40px); opacity: 0; }
// // // //                         to { transform: translateY(0); opacity: 1; }
// // // //                     }
// // // //                     ::-webkit-scrollbar {
// // // //                         width: 10px;
// // // //                     }
// // // //                     ::-webkit-scrollbar-track {
// // // //                         background: #f1f1f1;
// // // //                         border-radius: 10px;
// // // //                     }
// // // //                     ::-webkit-scrollbar-thumb {
// // // //                         background: #b085f5;
// // // //                         border-radius: 10px;
// // // //                     }
// // // //                     ::-webkit-scrollbar-thumb:hover {
// // // //                         background: #7b2cbf;
// // // //                     }
// // // //                 `}
// // // //                 </style>
// // // //             </Box>
// // // //         </div >
// // // //     );
// // // // };

// // // // export default NotificationContext;





// // // import React, { useState, useEffect } from "react";
// // // import { Link } from "react-router-dom";

// // // import {
// // //     FaBell,
// // //     FaHistory,
// // //     FaCog,
// // //     FaToggleOn,
// // //     FaToggleOff,
// // //     FaSms,
// // //     FaMobileAlt,
// // //     FaCheckCircle,
// // //     FaExclamationTriangle,
// // //     FaCalendarAlt,
// // //     FaFilter,
// // //     FaTrash,
// // //     FaSearch,
// // //     FaEye,
// // //     FaDatabase,
// // //     FaShoppingCart,
// // //     FaStar,
// // //     FaRupeeSign,
// // //     FaBox,
// // //     FaEnvelope,
// // //     FaSortAmountDown,
// // //     FaSortAmountUp
// // // } from "react-icons/fa";

// // // function NotificationContext() {
// // //     // State for SMS notification settings
// // //     const [smsSettings, setSmsSettings] = useState({
// // //         enabled: true,
// // //         lowStockAlerts: true,
// // //         highValueOrders: true,
// // //         orderConfirmation: false,
// // //         paymentUpdates: true,
// // //         criticalAlerts: true,
// // //         dailySummary: false,
// // //         phoneNumber: "+91 9876543210"
// // //     });

// // //     // State for alert configurations
// // //     const [alerts, setAlerts] = useState({
// // //         lowStock: {
// // //             enabled: true,
// // //             threshold: 10,
// // //             notifyViaSms: true,
// // //             notifyViaPush: true,
// // //             notifyViaEmail: true,
// // //             category: 'inventory',
// // //             frequency: 'immediate'
// // //         },
// // //         highValueOrders: {
// // //             enabled: true,
// // //             threshold: 5000,
// // //             notifyViaSms: true,
// // //             notifyViaPush: true,
// // //             notifyViaEmail: false,
// // //             category: 'orders',
// // //             frequency: 'immediate'
// // //         },
// // //         newOrders: {
// // //             enabled: false,
// // //             threshold: 0,
// // //             notifyViaSms: false,
// // //             notifyViaPush: true,
// // //             notifyViaEmail: false,
// // //             category: 'orders',
// // //             frequency: 'immediate'
// // //         },
// // //         customerReviews: {
// // //             enabled: true,
// // //             ratingThreshold: 3,
// // //             notifyViaSms: false,
// // //             notifyViaPush: false,
// // //             notifyViaEmail: true,
// // //             category: 'reviews',
// // //             frequency: 'daily'
// // //         },
// // //         paymentReceived: {
// // //             enabled: true,
// // //             threshold: 0,
// // //             notifyViaSms: true,
// // //             notifyViaPush: true,
// // //             notifyViaEmail: true,
// // //             category: 'payments',
// // //             frequency: 'immediate'
// // //         }
// // //     });

// // //     // State for notification history
// // //     const [notifications, setNotifications] = useState([
// // //         {
// // //             id: 1,
// // //             type: 'stock',
// // //             title: 'Low Stock Alert',
// // //             message: 'Paneer Tikka is running low (5 items left)',
// // //             timestamp: '2024-03-20 14:30:00',
// // //             read: true,
// // //             channel: 'sms',
// // //             priority: 'high'
// // //         },
// // //         {
// // //             id: 2,
// // //             type: 'order',
// // //             title: 'High-Value Order',
// // //             message: 'Order #ORD-78945 worth ₹12,500 received',
// // //             timestamp: '2024-03-20 12:15:00',
// // //             read: true,
// // //             channel: 'sms',
// // //             priority: 'high'
// // //         },
// // //         {
// // //             id: 3,
// // //             type: 'payment',
// // //             title: 'Payment Received',
// // //             message: '₹8,750 payment processed for Order #ORD-78945',
// // //             timestamp: '2024-03-20 09:20:00',
// // //             read: false,
// // //             channel: 'sms',
// // //             priority: 'medium'
// // //         },
// // //         {
// // //             id: 4,
// // //             type: 'stock',
// // //             title: 'Critical Stock Level',
// // //             message: 'Basmati Rice needs restocking (2 items left)',
// // //             timestamp: '2024-03-19 11:30:00',
// // //             read: true,
// // //             channel: 'sms',
// // //             priority: 'critical'
// // //         },
// // //         {
// // //             id: 5,
// // //             type: 'system',
// // //             title: 'System Maintenance',
// // //             message: 'Scheduled maintenance on March 22, 2:00 AM - 4:00 AM',
// // //             timestamp: '2024-03-19 16:10:00',
// // //             read: false,
// // //             channel: 'push',
// // //             priority: 'low'
// // //         },
// // //         {
// // //             id: 6,
// // //             type: 'order',
// // //             title: 'Order Confirmation',
// // //             message: 'Order #ORD-78946 confirmed for ₹2,450',
// // //             timestamp: '2024-03-19 14:45:00',
// // //             read: true,
// // //             channel: 'sms',
// // //             priority: 'medium'
// // //         },
// // //         {
// // //             id: 7,
// // //             type: 'stock',
// // //             title: 'Restock Reminder',
// // //             message: 'Butter Chicken Masala running low (8 items left)',
// // //             timestamp: '2024-03-19 10:15:00',
// // //             read: true,
// // //             channel: 'sms',
// // //             priority: 'medium'
// // //         },
// // //         {
// // //             id: 8,
// // //             type: 'payment',
// // //             title: 'Payment Failed',
// // //             message: 'Payment failed for Order #ORD-78947. Please check.',
// // //             timestamp: '2024-03-18 18:30:00',
// // //             read: true,
// // //             channel: 'sms',
// // //             priority: 'high'
// // //         }
// // //     ]);

// // //     // State for UI
// // //     const [activeTab, setActiveTab] = useState('smsSettings');
// // //     const [filterType, setFilterType] = useState('all');
// // //     const [searchQuery, setSearchQuery] = useState('');
// // //     const [sortOrder, setSortOrder] = useState('newest');
// // //     const [isMobile, setIsMobile] = useState(false);

// // //     // Check screen size
// // //     useEffect(() => {
// // //         const checkMobile = () => {
// // //             setIsMobile(window.innerWidth <= 768);
// // //         };

// // //         checkMobile();
// // //         window.addEventListener('resize', checkMobile);
// // //         return () => window.removeEventListener('resize', checkMobile);
// // //     }, []);

// // //     // Toggle SMS settings
// // //     const toggleSmsSetting = (setting) => {
// // //         setSmsSettings(prev => ({
// // //             ...prev,
// // //             [setting]: !prev[setting]
// // //         }));
// // //     };

// // //     // Update SMS phone number
// // //     const updatePhoneNumber = (value) => {
// // //         setSmsSettings(prev => ({
// // //             ...prev,
// // //             phoneNumber: value
// // //         }));
// // //     };

// // //     // Toggle alert configuration
// // //     const toggleAlert = (alertType) => {
// // //         setAlerts(prev => ({
// // //             ...prev,
// // //             [alertType]: {
// // //                 ...prev[alertType],
// // //                 enabled: !prev[alertType].enabled
// // //             }
// // //         }));
// // //     };

// // //     // Update alert threshold
// // //     const updateAlertThreshold = (alertType, value) => {
// // //         setAlerts(prev => ({
// // //             ...prev,
// // //             [alertType]: {
// // //                 ...prev[alertType],
// // //                 threshold: parseInt(value) || 0
// // //             }
// // //         }));
// // //     };

// // //     // Toggle notification channel for alert
// // //     const toggleAlertChannel = (alertType, channel) => {
// // //         setAlerts(prev => ({
// // //             ...prev,
// // //             [alertType]: {
// // //                 ...prev[alertType],
// // //                 [channel]: !prev[alertType][channel]
// // //             }
// // //         }));
// // //     };

// // //     // Update alert frequency
// // //     const updateAlertFrequency = (alertType, frequency) => {
// // //         setAlerts(prev => ({
// // //             ...prev,
// // //             [alertType]: {
// // //                 ...prev[alertType],
// // //                 frequency: frequency
// // //             }
// // //         }));
// // //     };

// // //     // Mark notification as read
// // //     const markAsRead = (id) => {
// // //         setNotifications(prev =>
// // //             prev.map(notification =>
// // //                 notification.id === id ? { ...notification, read: true } : notification
// // //             )
// // //         );
// // //     };

// // //     // Mark all as read
// // //     const markAllAsRead = () => {
// // //         setNotifications(prev =>
// // //             prev.map(notification => ({ ...notification, read: true }))
// // //         );
// // //     };

// // //     // Delete notification
// // //     const deleteNotification = (id) => {
// // //         setNotifications(prev =>
// // //             prev.filter(notification => notification.id !== id)
// // //         );
// // //     };

// // //     // Clear all notifications
// // //     const clearAllNotifications = () => {
// // //         setNotifications([]);
// // //     };

// // //     // Filter and sort notifications
// // //     const filteredNotifications = notifications
// // //         .filter(notification => {
// // //             const matchesType = filterType === 'all' || notification.type === filterType;
// // //             const matchesSearch =
// // //                 notification.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
// // //                 notification.message.toLowerCase().includes(searchQuery.toLowerCase());

// // //             return matchesType && matchesSearch;
// // //         })
// // //         .sort((a, b) => {
// // //             const dateA = new Date(a.timestamp);
// // //             const dateB = new Date(b.timestamp);
// // //             return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
// // //         });

// // //     // Get unread count
// // //     const unreadCount = notifications.filter(n => !n.read).length;

// // //     // Get priority color
// // //     const getPriorityColor = (priority) => {
// // //         switch (priority) {
// // //             case 'critical': return '#f44336';
// // //             case 'high': return '#ff9800';
// // //             case 'medium': return '#2196f3';
// // //             case 'low': return '#4caf50';
// // //             default: return '#757575';
// // //         }
// // //     };

// // //     // Get type icon
// // //     const getTypeIcon = (type) => {
// // //         switch (type) {
// // //             case 'stock': return <FaBox />;
// // //             case 'order': return <FaShoppingCart />;
// // //             case 'review': return <FaStar />;
// // //             case 'payment': return <FaRupeeSign />;
// // //             case 'system': return <FaCog />;
// // //             default: return <FaBell />;
// // //         }
// // //     };

// // //     // Get channel icon
// // //     const getChannelIcon = (channel) => {
// // //         switch (channel) {
// // //             case 'sms': return <FaSms />;
// // //             case 'push': return <FaMobileAlt />;
// // //             case 'email': return <FaEnvelope />;
// // //             default: return <FaBell />;
// // //         }
// // //     };

// // //     // Tabs configuration
// // //     const tabs = [
// // //         { id: 'smsSettings', label: 'SMS Settings', icon: <FaSms /> },
// // //         { id: 'alerts', label: 'Custom Alerts', icon: <FaExclamationTriangle /> },
// // //         { id: 'history', label: 'Notification History', icon: <FaHistory /> }
// // //     ];

// // //     // Notification types for filtering
// // //     const notificationTypes = [
// // //         { id: 'all', label: 'All' },
// // //         { id: 'stock', label: 'Stock' },
// // //         { id: 'order', label: 'Orders' },
// // //         { id: 'payment', label: 'Payments' },
// // //         { id: 'system', label: 'System' }
// // //     ];

// // //     return (
// // //         <div
// // //             style={{
// // //                 maxWidth: '1124px',
// // //                 margin: '107px auto', // top/bottom 107px, left/right auto → centers horizontally
// // //                 padding: isMobile ? '10px' : '20px',
// // //                 height: "85vh",
// // //                 width: "90vw",
// // //                 scrollbarWidth: "none",
// // //                 overflow: 'auto',
// // //                 fontFamily: 'Arial, sans-serif',
// // //                 // backgroundColor: '#f5f5f5',
// // //                 // minHeight: '100vh',
// // //                 overflowX: 'hidden',
// // //                 boxSizing: 'border-box',
// // //                 textAlign: 'center', // optional, centers inline content inside container
// // //             }}
// // //         >

// // //             {/* Tabs */}
// // //             <div style={{
// // //                 display: 'flex',
// // //                 justifyContent: 'center',
// // //                 gap: isMobile ? '5px' : '10px',
// // //                 marginBottom: '20px',
// // //                 backgroundColor: 'white',
// // //                 padding: isMobile ? '8px' : '10px',
// // //                 borderRadius: '10px',
// // //                 //boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
// // //                 overflowX: isMobile ? 'auto' : 'visible',
// // //                 WebkitOverflowScrolling: 'touch',
// // //                 scrollbarWidth: 'none',
// // //                 msOverflowStyle: 'none'
// // //             }}>

// // //                 <p
// // //                     className="breadcrumb maamaas-home-bredcum"
// // //                     style={{
// // //                         position: "fixed",
// // //                         top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
// // //                         left: "2vw",
// // //                         width: "100%",
// // //                         backgroundColor: "#fff",
// // //                         zIndex: 1000,
// // //                         padding: "10px 0",
// // //                         fontSize: isMobile ? "16px" : "18px",
// // //                         fontWeight: isMobile ? "normal" : "bold",
// // //                         textAlign: "center",
// // //                         margin: 0,
// // //                     }}
// // //                 >
                  
// // //                     <Link
// // //                         to="/fooddashboard"
// // //                         style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
// // //                     >
// // //                         Food & Beverages
// // //                     </Link>
// // //                     <span className="separator"> &gt; </span>
// // //                     <Link

// // //                         style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
// // //                     >
// // //                         Notifications 
// // //                     </Link>

// // //                 </p>

// // //                 {tabs.map(tab => (
// // //                     <button
// // //                         key={tab.id}
// // //                         onClick={() => {
// // //                             setActiveTab(tab.id);
// // //                             // Smooth scroll to top on mobile
// // //                             if (isMobile) {
// // //                                 window.scrollTo({ top: 0, behavior: 'smooth' });
// // //                             }
// // //                         }}
// // //                         style={{
// // //                             padding: isMobile ? '8px 12px' : '12px 20px',
// // //                             border: 'none',
// // //                             backgroundColor: activeTab === tab.id ? '#A055B0' : '#f5f5f5',
// // //                             color: activeTab === tab.id ? 'white' : '#333',
// // //                             borderRadius: '8px',
// // //                             cursor: 'pointer',
// // //                             display: 'flex',
// // //                             alignItems: 'center',
// // //                             gap: isMobile ? '6px' : '8px',
// // //                             fontSize: isMobile ? '12px' : '14px',
// // //                             fontWeight: '600',
// // //                             transition: 'all 0.3s ease',
// // //                             flexShrink: 0,
// // //                             whiteSpace: 'nowrap'
// // //                         }}
// // //                     >
// // //                         {tab.icon} {tab.label}
// // //                     </button>
// // //                 ))}
// // //             </div>

// // //             {/* Tab Content */}
// // //             <div style={{
// // //                 minHeight: '500px',
// // //                 overflow: 'visible'
// // //             }}>
// // //                 {/* SMS Notification Settings Tab */}
// // //                 {activeTab === 'smsSettings' && (
// // //                     <div style={{
// // //                         backgroundColor: 'white',
// // //                         borderRadius: '10px',
// // //                         padding: isMobile ? '15px' : '30px',
// // //                         boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
// // //                         marginBottom: '20px'
// // //                     }}>
// // //                         <div style={{
// // //                             display: 'flex',
// // //                             alignItems: 'center',
// // //                             gap: '15px',
// // //                             marginBottom: '20px',
// // //                             flexDirection: isMobile ? 'column' : 'row',
// // //                             textAlign: isMobile ? 'center' : 'left'
// // //                         }}>
// // //                             <div style={{
// // //                                 width: isMobile ? '50px' : '60px',
// // //                                 height: isMobile ? '50px' : '60px',
// // //                                 borderRadius: '50%',
// // //                                 backgroundColor: '#e3f2fd',
// // //                                 display: 'flex',
// // //                                 alignItems: 'center',
// // //                                 justifyContent: 'center',
// // //                                 flexShrink: 0
// // //                             }}>
// // //                                 <FaSms style={{
// // //                                     fontSize: isMobile ? '24px' : '28px',
// // //                                     color: '#2196F3'
// // //                                 }} />
// // //                             </div>
// // //                             <div style={{ flex: 1 }}>
// // //                                 <h3 style={{
// // //                                     margin: 0,
// // //                                     color: '#333',
// // //                                     fontSize: isMobile ? '18px' : '24px'
// // //                                 }}>
// // //                                     SMS Notification Settings
// // //                                 </h3>
// // //                                 <p style={{
// // //                                     margin: '5px 0 0 0',
// // //                                     color: '#666',
// // //                                     fontSize: isMobile ? '13px' : '14px'
// // //                                 }}>
// // //                                     Configure how you receive SMS alerts for your business
// // //                                 </p>
// // //                             </div>
// // //                         </div>

// // //                         {/* SMS Toggle */}
// // //                         <div style={{
// // //                             display: 'flex',
// // //                             justifyContent: 'space-between',
// // //                             alignItems: 'center',
// // //                             padding: isMobile ? '15px' : '20px',
// // //                             backgroundColor: smsSettings.enabled ? '#e8f5e9' : '#f5f5f5',
// // //                             borderRadius: '10px',
// // //                             marginBottom: '20px'
// // //                         }}>
// // //                             <div>
// // //                                 <h4 style={{
// // //                                     margin: '0 0 5px 0',
// // //                                     color: '#333',
// // //                                     fontSize: isMobile ? '16px' : '18px'
// // //                                 }}>
// // //                                     Enable SMS Notifications
// // //                                 </h4>
// // //                                 <p style={{
// // //                                     margin: 0,
// // //                                     color: '#666',
// // //                                     fontSize: isMobile ? '13px' : '14px'
// // //                                 }}>
// // //                                     {smsSettings.enabled
// // //                                         ? 'SMS notifications are currently active'
// // //                                         : 'SMS notifications are disabled'
// // //                                     }
// // //                                 </p>
// // //                             </div>
// // //                             <button
// // //                                 onClick={() => toggleSmsSetting('enabled')}
// // //                                 style={{
// // //                                     background: 'none',
// // //                                     border: 'none',
// // //                                     fontSize: isMobile ? '32px' : '40px',
// // //                                     color: smsSettings.enabled ? '#4CAF50' : '#ccc',
// // //                                     cursor: 'pointer',
// // //                                     display: 'flex',
// // //                                     alignItems: 'center'
// // //                                 }}
// // //                             >
// // //                                 {smsSettings.enabled ? <FaToggleOn /> : <FaToggleOff />}
// // //                             </button>
// // //                         </div>

// // //                         {/* Phone Number Input */}
// // //                         {smsSettings.enabled && (
// // //                             <div style={{
// // //                                 padding: isMobile ? '15px' : '20px',
// // //                                 backgroundColor: '#f0f8ff',
// // //                                 borderRadius: '10px',
// // //                                 marginBottom: '20px'
// // //                             }}>
// // //                                 <h4 style={{
// // //                                     margin: '0 0 15px 0',
// // //                                     color: '#333',
// // //                                     fontSize: isMobile ? '16px' : '18px'
// // //                                 }}>
// // //                                     <FaMobileAlt style={{ marginRight: '10px' }} />
// // //                                     Phone Number for SMS Alerts
// // //                                 </h4>
// // //                                 <div style={{
// // //                                     display: 'flex',
// // //                                     gap: '10px',
// // //                                     alignItems: 'center',
// // //                                     flexDirection: isMobile ? 'column' : 'row'
// // //                                 }}>
// // //                                     <input
// // //                                         type="tel"
// // //                                         value={smsSettings.phoneNumber}
// // //                                         onChange={(e) => updatePhoneNumber(e.target.value)}
// // //                                         style={{
// // //                                             flex: 1,
// // //                                             padding: '12px',
// // //                                             border: '1px solid #ddd',
// // //                                             borderRadius: '6px',
// // //                                             fontSize: isMobile ? '14px' : '16px',
// // //                                             width: '100%',
// // //                                             boxSizing: 'border-box'
// // //                                         }}
// // //                                         placeholder="Enter phone number with country code"
// // //                                     />
// // //                                     <button
// // //                                         onClick={() => alert('Phone number updated!')}
// // //                                         style={{
// // //                                             padding: '12px 24px',
// // //                                             backgroundColor: '#2196F3',
// // //                                             color: 'white',
// // //                                             border: 'none',
// // //                                             borderRadius: '6px',
// // //                                             cursor: 'pointer',
// // //                                             fontSize: isMobile ? '13px' : '14px',
// // //                                             fontWeight: '600',
// // //                                             width: isMobile ? '100%' : 'auto',
// // //                                             flexShrink: 0
// // //                                         }}
// // //                                     >
// // //                                         Update
// // //                                     </button>
// // //                                 </div>
// // //                                 <p style={{
// // //                                     margin: '10px 0 0 0',
// // //                                     color: '#666',
// // //                                     fontSize: isMobile ? '12px' : '13px'
// // //                                 }}>
// // //                                     <FaExclamationTriangle style={{ marginRight: '5px' }} />
// // //                                     Standard SMS rates may apply. For international numbers, check with your carrier.
// // //                                 </p>
// // //                             </div>
// // //                         )}

// // //                         {/* SMS Alert Types */}
// // //                         {smsSettings.enabled && (
// // //                             <div>
// // //                                 <h4 style={{
// // //                                     margin: '0 0 20px 0',
// // //                                     color: '#333',
// // //                                     fontSize: isMobile ? '16px' : '18px'
// // //                                 }}>
// // //                                     Select SMS Alert Types
// // //                                 </h4>
// // //                                 <div style={{
// // //                                     display: 'grid',
// // //                                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
// // //                                     gap: '15px'
// // //                                 }}>
// // //                                     {[
// // //                                         { key: 'lowStockAlerts', label: 'Low Stock Alerts', description: 'Get notified when inventory is running low' },
// // //                                         { key: 'highValueOrders', label: 'High-Value Orders', description: 'Alerts for orders above ₹5,000' },
// // //                                         { key: 'orderConfirmation', label: 'Order Confirmations', description: 'SMS for every new order' },
// // //                                         { key: 'paymentUpdates', label: 'Payment Updates', description: 'Payment received/failed notifications' },
// // //                                         { key: 'criticalAlerts', label: 'Critical Alerts', description: 'Emergency system notifications' },
// // //                                         { key: 'dailySummary', label: 'Daily Summary', description: 'End-of-day business summary' }
// // //                                     ].map(item => (
// // //                                         <div key={item.key} style={{
// // //                                             display: 'flex',
// // //                                             justifyContent: 'space-between',
// // //                                             alignItems: 'center',
// // //                                             padding: '15px',
// // //                                             backgroundColor: '#f9f9f9',
// // //                                             borderRadius: '8px',
// // //                                             border: '1px solid #e0e0e0'
// // //                                         }}>
// // //                                             <div style={{ flex: 1, marginRight: '15px' }}>
// // //                                                 <div style={{
// // //                                                     fontSize: isMobile ? '14px' : '16px',
// // //                                                     fontWeight: '600',
// // //                                                     color: smsSettings[item.key] ? '#333' : '#999'
// // //                                                 }}>
// // //                                                     {item.label}
// // //                                                 </div>
// // //                                                 <div style={{
// // //                                                     fontSize: isMobile ? '12px' : '13px',
// // //                                                     color: smsSettings[item.key] ? '#666' : '#bbb',
// // //                                                     marginTop: '5px'
// // //                                                 }}>
// // //                                                     {item.description}
// // //                                                 </div>
// // //                                             </div>
// // //                                             <button
// // //                                                 onClick={() => toggleSmsSetting(item.key)}
// // //                                                 style={{
// // //                                                     background: 'none',
// // //                                                     border: 'none',
// // //                                                     fontSize: isMobile ? '24px' : '28px',
// // //                                                     color: smsSettings[item.key] ? '#4CAF50' : '#ccc',
// // //                                                     cursor: 'pointer',
// // //                                                     display: 'flex',
// // //                                                     alignItems: 'center',
// // //                                                     flexShrink: 0
// // //                                                 }}
// // //                                             >
// // //                                                 {smsSettings[item.key] ? <FaToggleOn /> : <FaToggleOff />}
// // //                                             </button>
// // //                                         </div>
// // //                                     ))}
// // //                                 </div>
// // //                             </div>
// // //                         )}

// // //                         {/* Save Button */}
// // //                         <div style={{ marginTop: '30px', textAlign: 'center' }}>
// // //                             <button
// // //                                 onClick={() => alert('SMS settings saved successfully!')}
// // //                                 style={{
// // //                                     backgroundColor: '#4CAF50',
// // //                                     color: 'white',
// // //                                     border: 'none',
// // //                                     padding: isMobile ? '12px 30px' : '15px 40px',
// // //                                     borderRadius: '8px',
// // //                                     cursor: 'pointer',
// // //                                     fontSize: isMobile ? '14px' : '16px',
// // //                                     fontWeight: '600',
// // //                                     display: 'inline-flex',
// // //                                     alignItems: 'center',
// // //                                     gap: '10px',
// // //                                     boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
// // //                                     transition: 'all 0.3s ease'
// // //                                 }}
// // //                                 onMouseEnter={(e) => {
// // //                                     e.currentTarget.style.backgroundColor = '#388E3C';
// // //                                     e.currentTarget.style.transform = 'translateY(-2px)';
// // //                                 }}
// // //                                 onMouseLeave={(e) => {
// // //                                     e.currentTarget.style.backgroundColor = '#4CAF50';
// // //                                     e.currentTarget.style.transform = 'translateY(0)';
// // //                                 }}
// // //                             >
// // //                                 <FaCheckCircle /> Save SMS Settings
// // //                             </button>
// // //                         </div>
// // //                     </div>
// // //                 )}

// // //                 {/* Custom Alert Configuration Tab */}
// // //                 {activeTab === 'alerts' && (
// // //                     <div style={{
// // //                         backgroundColor: 'white',
// // //                         borderRadius: '10px',
// // //                         padding: isMobile ? '15px' : '30px',
// // //                         boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
// // //                         marginBottom: '20px'
// // //                     }}>
// // //                         <div style={{
// // //                             display: 'flex',
// // //                             alignItems: 'center',
// // //                             gap: '15px',
// // //                             marginBottom: '20px',
// // //                             flexDirection: isMobile ? 'column' : 'row',
// // //                             textAlign: isMobile ? 'center' : 'left'
// // //                         }}>
// // //                             <div style={{
// // //                                 width: isMobile ? '50px' : '60px',
// // //                                 height: isMobile ? '50px' : '60px',
// // //                                 borderRadius: '50%',
// // //                                 backgroundColor: '#fff3e0',
// // //                                 display: 'flex',
// // //                                 alignItems: 'center',
// // //                                 justifyContent: 'center',
// // //                                 flexShrink: 0
// // //                             }}>
// // //                                 <FaExclamationTriangle style={{
// // //                                     fontSize: isMobile ? '24px' : '28px',
// // //                                     color: '#FF9800'
// // //                                 }} />
// // //                             </div>
// // //                             <div style={{ flex: 1 }}>
// // //                                 <h3 style={{
// // //                                     margin: 0,
// // //                                     color: '#333',
// // //                                     fontSize: isMobile ? '18px' : '24px'
// // //                                 }}>
// // //                                     Custom Alert Configuration
// // //                                 </h3>
// // //                                 <p style={{
// // //                                     margin: '5px 0 0 0',
// // //                                     color: '#666',
// // //                                     fontSize: isMobile ? '13px' : '14px'
// // //                                 }}>
// // //                                     Set up custom alerts for specific business events
// // //                                 </p>
// // //                             </div>
// // //                         </div>

// // //                         {/* Alert Configuration Cards */}
// // //                         <div style={{
// // //                             display: 'grid',
// // //                             gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
// // //                             gap: '20px',
// // //                             marginBottom: '30px'
// // //                         }}>
// // //                             {/* Low Stock Alert */}
// // //                             <div style={{
// // //                                 border: '1px solid #e0e0e0',
// // //                                 borderRadius: '12px',
// // //                                 padding: isMobile ? '15px' : '25px',
// // //                                 backgroundColor: '#fff',
// // //                                 boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
// // //                             }}>
// // //                                 <div style={{
// // //                                     display: 'flex',
// // //                                     justifyContent: 'space-between',
// // //                                     alignItems: 'flex-start',
// // //                                     marginBottom: '15px'
// // //                                 }}>
// // //                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// // //                                         <div style={{
// // //                                             width: '40px',
// // //                                             height: '40px',
// // //                                             borderRadius: '50%',
// // //                                             backgroundColor: alerts.lowStock.enabled ? '#e8f5e9' : '#f5f5f5',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             justifyContent: 'center',
// // //                                             flexShrink: 0
// // //                                         }}>
// // //                                             <FaBox style={{
// // //                                                 fontSize: '20px',
// // //                                                 color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc'
// // //                                             }} />
// // //                                         </div>
// // //                                         <div>
// // //                                             <h4 style={{
// // //                                                 margin: 0,
// // //                                                 color: '#333',
// // //                                                 fontSize: isMobile ? '16px' : '18px'
// // //                                             }}>
// // //                                                 Low Stock Alert
// // //                                             </h4>
// // //                                             <p style={{
// // //                                                 margin: '5px 0 0 0',
// // //                                                 color: '#666',
// // //                                                 fontSize: isMobile ? '12px' : '13px'
// // //                                             }}>
// // //                                                 Get notified when inventory is running low
// // //                                             </p>
// // //                                         </div>
// // //                                     </div>
// // //                                     <button
// // //                                         onClick={() => toggleAlert('lowStock')}
// // //                                         style={{
// // //                                             background: 'none',
// // //                                             border: 'none',
// // //                                             fontSize: isMobile ? '28px' : '32px',
// // //                                             color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc',
// // //                                             cursor: 'pointer',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             flexShrink: 0
// // //                                         }}
// // //                                     >
// // //                                         {alerts.lowStock.enabled ? <FaToggleOn /> : <FaToggleOff />}
// // //                                     </button>
// // //                                 </div>

// // //                                 {alerts.lowStock.enabled && (
// // //                                     <div>
// // //                                         <div style={{ marginBottom: '15px' }}>
// // //                                             <label style={{
// // //                                                 display: 'block',
// // //                                                 marginBottom: '8px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 fontWeight: '600',
// // //                                                 color: '#333'
// // //                                             }}>
// // //                                                 Alert when stock falls below:
// // //                                             </label>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 alignItems: 'center',
// // //                                                 gap: '10px'
// // //                                             }}>
// // //                                                 <input
// // //                                                     type="number"
// // //                                                     value={alerts.lowStock.threshold}
// // //                                                     onChange={(e) => updateAlertThreshold('lowStock', e.target.value)}
// // //                                                     min="1"
// // //                                                     max="100"
// // //                                                     style={{
// // //                                                         width: isMobile ? '80px' : '100px',
// // //                                                         padding: '10px',
// // //                                                         border: '2px solid #e0e0e0',
// // //                                                         borderRadius: '6px',
// // //                                                         fontSize: isMobile ? '14px' : '16px'
// // //                                                     }}
// // //                                                 />
// // //                                                 <span style={{
// // //                                                     fontSize: isMobile ? '13px' : '14px',
// // //                                                     color: '#666'
// // //                                                 }}>
// // //                                                     items
// // //                                                 </span>
// // //                                             </div>
// // //                                         </div>

// // //                                         <div style={{ marginBottom: '15px' }}>
// // //                                             <label style={{
// // //                                                 display: 'block',
// // //                                                 marginBottom: '10px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 fontWeight: '600',
// // //                                                 color: '#333'
// // //                                             }}>
// // //                                                 Notification Channels:
// // //                                             </label>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 gap: '10px',
// // //                                                 flexWrap: 'wrap'
// // //                                             }}>
// // //                                                 {[
// // //                                                     { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
// // //                                                     { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
// // //                                                     { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
// // //                                                 ].map(channel => (
// // //                                                     <button
// // //                                                         key={channel.key}
// // //                                                         onClick={() => toggleAlertChannel('lowStock', channel.key)}
// // //                                                         style={{
// // //                                                             padding: '6px 12px',
// // //                                                             border: `2px solid ${alerts.lowStock[channel.key] ? '#4CAF50' : '#e0e0e0'}`,
// // //                                                             backgroundColor: alerts.lowStock[channel.key] ? '#e8f5e9' : 'white',
// // //                                                             color: alerts.lowStock[channel.key] ? '#2e7d32' : '#666',
// // //                                                             borderRadius: '20px',
// // //                                                             cursor: 'pointer',
// // //                                                             display: 'flex',
// // //                                                             alignItems: 'center',
// // //                                                             gap: '6px',
// // //                                                             fontSize: isMobile ? '12px' : '13px',
// // //                                                             fontWeight: '600',
// // //                                                             flexShrink: 0
// // //                                                         }}
// // //                                                     >
// // //                                                         {channel.icon} {channel.label}
// // //                                                     </button>
// // //                                                 ))}
// // //                                             </div>
// // //                                         </div>

// // //                                         <div style={{
// // //                                             padding: '10px',
// // //                                             backgroundColor: '#e8f5e9',
// // //                                             borderRadius: '8px',
// // //                                             fontSize: isMobile ? '12px' : '13px',
// // //                                             color: '#2e7d32',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             gap: '8px'
// // //                                         }}>
// // //                                             <FaCheckCircle />
// // //                                             Alert active: Notify when stock is below {alerts.lowStock.threshold} items
// // //                                         </div>
// // //                                     </div>
// // //                                 )}
// // //                             </div>

// // //                             {/* High-Value Orders Alert */}
// // //                             <div style={{
// // //                                 border: '1px solid #e0e0e0',
// // //                                 borderRadius: '12px',
// // //                                 padding: isMobile ? '15px' : '25px',
// // //                                 backgroundColor: '#fff',
// // //                                 boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
// // //                             }}>
// // //                                 <div style={{
// // //                                     display: 'flex',
// // //                                     justifyContent: 'space-between',
// // //                                     alignItems: 'flex-start',
// // //                                     marginBottom: '15px'
// // //                                 }}>
// // //                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// // //                                         <div style={{
// // //                                             width: '40px',
// // //                                             height: '40px',
// // //                                             borderRadius: '50%',
// // //                                             backgroundColor: alerts.highValueOrders.enabled ? '#e3f2fd' : '#f5f5f5',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             justifyContent: 'center',
// // //                                             flexShrink: 0
// // //                                         }}>
// // //                                             <FaRupeeSign style={{
// // //                                                 fontSize: '20px',
// // //                                                 color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc'
// // //                                             }} />
// // //                                         </div>
// // //                                         <div>
// // //                                             <h4 style={{
// // //                                                 margin: 0,
// // //                                                 color: '#333',
// // //                                                 fontSize: isMobile ? '16px' : '18px'
// // //                                             }}>
// // //                                                 High-Value Orders
// // //                                             </h4>
// // //                                             <p style={{
// // //                                                 margin: '5px 0 0 0',
// // //                                                 color: '#666',
// // //                                                 fontSize: isMobile ? '12px' : '13px'
// // //                                             }}>
// // //                                                 Alerts for orders above specific value
// // //                                             </p>
// // //                                         </div>
// // //                                     </div>
// // //                                     <button
// // //                                         onClick={() => toggleAlert('highValueOrders')}
// // //                                         style={{
// // //                                             background: 'none',
// // //                                             border: 'none',
// // //                                             fontSize: isMobile ? '28px' : '32px',
// // //                                             color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc',
// // //                                             cursor: 'pointer',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             flexShrink: 0
// // //                                         }}
// // //                                     >
// // //                                         {alerts.highValueOrders.enabled ? <FaToggleOn /> : <FaToggleOff />}
// // //                                     </button>
// // //                                 </div>

// // //                                 {alerts.highValueOrders.enabled && (
// // //                                     <div>
// // //                                         <div style={{ marginBottom: '15px' }}>
// // //                                             <label style={{
// // //                                                 display: 'block',
// // //                                                 marginBottom: '8px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 fontWeight: '600',
// // //                                                 color: '#333'
// // //                                             }}>
// // //                                                 Alert for orders above:
// // //                                             </label>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 alignItems: 'center',
// // //                                                 gap: '10px'
// // //                                             }}>
// // //                                                 <span style={{
// // //                                                     fontSize: isMobile ? '16px' : '18px',
// // //                                                     fontWeight: 'bold',
// // //                                                     color: '#2196F3'
// // //                                                 }}>
// // //                                                     ₹
// // //                                                 </span>
// // //                                                 <input
// // //                                                     type="number"
// // //                                                     value={alerts.highValueOrders.threshold}
// // //                                                     onChange={(e) => updateAlertThreshold('highValueOrders', e.target.value)}
// // //                                                     min="1000"
// // //                                                     max="100000"
// // //                                                     style={{
// // //                                                         width: isMobile ? '100px' : '120px',
// // //                                                         padding: '10px',
// // //                                                         border: '2px solid #e0e0e0',
// // //                                                         borderRadius: '6px',
// // //                                                         fontSize: isMobile ? '14px' : '16px'
// // //                                                     }}
// // //                                                 />
// // //                                             </div>
// // //                                         </div>

// // //                                         <div style={{ marginBottom: '15px' }}>
// // //                                             <label style={{
// // //                                                 display: 'block',
// // //                                                 marginBottom: '10px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 fontWeight: '600',
// // //                                                 color: '#333'
// // //                                             }}>
// // //                                                 Notification Channels:
// // //                                             </label>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 gap: '10px',
// // //                                                 flexWrap: 'wrap'
// // //                                             }}>
// // //                                                 {[
// // //                                                     { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
// // //                                                     { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
// // //                                                     { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
// // //                                                 ].map(channel => (
// // //                                                     <button
// // //                                                         key={channel.key}
// // //                                                         onClick={() => toggleAlertChannel('highValueOrders', channel.key)}
// // //                                                         style={{
// // //                                                             padding: '6px 12px',
// // //                                                             border: `2px solid ${alerts.highValueOrders[channel.key] ? '#2196F3' : '#e0e0e0'}`,
// // //                                                             backgroundColor: alerts.highValueOrders[channel.key] ? '#e3f2fd' : 'white',
// // //                                                             color: alerts.highValueOrders[channel.key] ? '#1565c0' : '#666',
// // //                                                             borderRadius: '20px',
// // //                                                             cursor: 'pointer',
// // //                                                             display: 'flex',
// // //                                                             alignItems: 'center',
// // //                                                             gap: '6px',
// // //                                                             fontSize: isMobile ? '12px' : '13px',
// // //                                                             fontWeight: '600',
// // //                                                             flexShrink: 0
// // //                                                         }}
// // //                                                     >
// // //                                                         {channel.icon} {channel.label}
// // //                                                     </button>
// // //                                                 ))}
// // //                                             </div>
// // //                                         </div>

// // //                                         <div style={{
// // //                                             padding: '10px',
// // //                                             backgroundColor: '#e3f2fd',
// // //                                             borderRadius: '8px',
// // //                                             fontSize: isMobile ? '12px' : '13px',
// // //                                             color: '#1565c0',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             gap: '8px'
// // //                                         }}>
// // //                                             <FaCheckCircle />
// // //                                             Alert active: Notify for orders above ₹{alerts.highValueOrders.threshold.toLocaleString()}
// // //                                         </div>
// // //                                     </div>
// // //                                 )}
// // //                             </div>

// // //                             {/* Customer Reviews Alert */}
// // //                             <div style={{
// // //                                 border: '1px solid #e0e0e0',
// // //                                 borderRadius: '12px',
// // //                                 padding: isMobile ? '15px' : '25px',
// // //                                 backgroundColor: '#fff',
// // //                                 boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
// // //                             }}>
// // //                                 <div style={{
// // //                                     display: 'flex',
// // //                                     justifyContent: 'space-between',
// // //                                     alignItems: 'flex-start',
// // //                                     marginBottom: '15px'
// // //                                 }}>
// // //                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// // //                                         <div style={{
// // //                                             width: '40px',
// // //                                             height: '40px',
// // //                                             borderRadius: '50%',
// // //                                             backgroundColor: alerts.customerReviews.enabled ? '#fff3e0' : '#f5f5f5',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             justifyContent: 'center',
// // //                                             flexShrink: 0
// // //                                         }}>
// // //                                             <FaStar style={{
// // //                                                 fontSize: '20px',
// // //                                                 color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc'
// // //                                             }} />
// // //                                         </div>
// // //                                         <div>
// // //                                             <h4 style={{
// // //                                                 margin: 0,
// // //                                                 color: '#333',
// // //                                                 fontSize: isMobile ? '16px' : '18px'
// // //                                             }}>
// // //                                                 Customer Reviews
// // //                                             </h4>
// // //                                             <p style={{
// // //                                                 margin: '5px 0 0 0',
// // //                                                 color: '#666',
// // //                                                 fontSize: isMobile ? '12px' : '13px'
// // //                                             }}>
// // //                                                 Alerts for critical customer reviews
// // //                                             </p>
// // //                                         </div>
// // //                                     </div>
// // //                                     <button
// // //                                         onClick={() => toggleAlert('customerReviews')}
// // //                                         style={{
// // //                                             background: 'none',
// // //                                             border: 'none',
// // //                                             fontSize: isMobile ? '28px' : '32px',
// // //                                             color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc',
// // //                                             cursor: 'pointer',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             flexShrink: 0
// // //                                         }}
// // //                                     >
// // //                                         {alerts.customerReviews.enabled ? <FaToggleOn /> : <FaToggleOff />}
// // //                                     </button>
// // //                                 </div>

// // //                                 {alerts.customerReviews.enabled && (
// // //                                     <div>
// // //                                         <div style={{ marginBottom: '15px' }}>
// // //                                             <label style={{
// // //                                                 display: 'block',
// // //                                                 marginBottom: '8px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 fontWeight: '600',
// // //                                                 color: '#333'
// // //                                             }}>
// // //                                                 Alert for ratings below:
// // //                                             </label>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 alignItems: 'center',
// // //                                                 gap: '10px'
// // //                                             }}>
// // //                                                 <input
// // //                                                     type="number"
// // //                                                     value={alerts.customerReviews.ratingThreshold}
// // //                                                     onChange={(e) => updateAlertThreshold('customerReviews', e.target.value)}
// // //                                                     min="1"
// // //                                                     max="5"
// // //                                                     step="0.5"
// // //                                                     style={{
// // //                                                         width: isMobile ? '80px' : '100px',
// // //                                                         padding: '10px',
// // //                                                         border: '2px solid #e0e0e0',
// // //                                                         borderRadius: '6px',
// // //                                                         fontSize: isMobile ? '14px' : '16px'
// // //                                                     }}
// // //                                                 />
// // //                                                 <span style={{
// // //                                                     fontSize: isMobile ? '13px' : '14px',
// // //                                                     color: '#666'
// // //                                                 }}>
// // //                                                     stars
// // //                                                 </span>
// // //                                             </div>
// // //                                         </div>

// // //                                         <div style={{ marginBottom: '15px' }}>
// // //                                             <label style={{
// // //                                                 display: 'block',
// // //                                                 marginBottom: '10px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 fontWeight: '600',
// // //                                                 color: '#333'
// // //                                             }}>
// // //                                                 Notification Frequency:
// // //                                             </label>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 gap: '8px',
// // //                                                 flexWrap: 'wrap'
// // //                                             }}>
// // //                                                 {['immediate', 'hourly', 'daily'].map(freq => (
// // //                                                     <button
// // //                                                         key={freq}
// // //                                                         onClick={() => updateAlertFrequency('customerReviews', freq)}
// // //                                                         style={{
// // //                                                             padding: '6px 12px',
// // //                                                             border: `2px solid ${alerts.customerReviews.frequency === freq ? '#FF9800' : '#e0e0e0'}`,
// // //                                                             backgroundColor: alerts.customerReviews.frequency === freq ? '#fff3e0' : 'white',
// // //                                                             color: alerts.customerReviews.frequency === freq ? '#e65100' : '#666',
// // //                                                             borderRadius: '20px',
// // //                                                             cursor: 'pointer',
// // //                                                             fontSize: isMobile ? '12px' : '13px',
// // //                                                             fontWeight: '600',
// // //                                                             textTransform: 'capitalize',
// // //                                                             flexShrink: 0
// // //                                                         }}
// // //                                                     >
// // //                                                         {freq}
// // //                                                     </button>
// // //                                                 ))}
// // //                                             </div>
// // //                                         </div>

// // //                                         <div style={{
// // //                                             padding: '10px',
// // //                                             backgroundColor: '#fff3e0',
// // //                                             borderRadius: '8px',
// // //                                             fontSize: isMobile ? '12px' : '13px',
// // //                                             color: '#e65100',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             gap: '8px'
// // //                                         }}>
// // //                                             <FaCheckCircle />
// // //                                             Alert active: Notify for reviews below {alerts.customerReviews.ratingThreshold} stars
// // //                                         </div>
// // //                                     </div>
// // //                                 )}
// // //                             </div>
// // //                         </div>

// // //                         {/* Save All Alerts Button */}
// // //                         <div style={{ marginTop: '20px', textAlign: 'center' }}>
// // //                             <button
// // //                                 onClick={() => alert('All alert configurations saved successfully!')}
// // //                                 style={{
// // //                                     backgroundColor: '#A055B0',
// // //                                     color: 'white',
// // //                                     border: 'none',
// // //                                     padding: isMobile ? '12px 30px' : '15px 40px',
// // //                                     borderRadius: '8px',
// // //                                     cursor: 'pointer',
// // //                                     fontSize: isMobile ? '14px' : '16px',
// // //                                     fontWeight: '600',
// // //                                     display: 'inline-flex',
// // //                                     alignItems: 'center',
// // //                                     gap: '10px',
// // //                                     boxShadow: '0 4px 15px rgba(160, 85, 176, 0.3)',
// // //                                     transition: 'all 0.3s ease'
// // //                                 }}
// // //                                 onMouseEnter={(e) => {
// // //                                     e.currentTarget.style.backgroundColor = '#8a4b9b';
// // //                                     e.currentTarget.style.transform = 'translateY(-2px)';
// // //                                 }}
// // //                                 onMouseLeave={(e) => {
// // //                                     e.currentTarget.style.backgroundColor = '#A055B0';
// // //                                     e.currentTarget.style.transform = 'translateY(0)';
// // //                                 }}
// // //                             >
// // //                                 <FaCheckCircle /> Save All Alert Configurations
// // //                             </button>
// // //                         </div>
// // //                     </div>
// // //                 )}

// // //                 {/* Notification History Tab */}
// // //                 {activeTab === 'history' && (
// // //                     <div style={{
// // //                         backgroundColor: 'white',
// // //                         borderRadius: '10px',
// // //                         padding: isMobile ? '15px' : '30px',
// // //                         boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
// // //                     }}>
// // //                         <div style={{
// // //                             display: 'flex',
// // //                             justifyContent: 'space-between',
// // //                             alignItems: 'center',
// // //                             marginBottom: '20px',
// // //                             flexWrap: 'wrap',
// // //                             gap: '15px',
// // //                             flexDirection: isMobile ? 'column' : 'row'
// // //                         }}>
// // //                             <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
// // //                                 <h3 style={{
// // //                                     margin: 0,
// // //                                     color: '#333',
// // //                                     fontSize: isMobile ? '18px' : '24px'
// // //                                 }}>
// // //                                     Notification History
// // //                                 </h3>
// // //                                 <p style={{
// // //                                     margin: '5px 0 0 0',
// // //                                     color: '#666',
// // //                                     fontSize: isMobile ? '13px' : '14px'
// // //                                 }}>
// // //                                     View all your past notifications
// // //                                 </p>
// // //                             </div>

// // //                             <div style={{
// // //                                 display: 'flex',
// // //                                 gap: '10px',
// // //                                 flexWrap: 'wrap',
// // //                                 justifyContent: isMobile ? 'center' : 'flex-end'
// // //                             }}>
// // //                                 <button
// // //                                     onClick={markAllAsRead}
// // //                                     style={{
// // //                                         backgroundColor: '#4CAF50',
// // //                                         color: 'white',
// // //                                         border: 'none',
// // //                                         padding: isMobile ? '8px 16px' : '10px 20px',
// // //                                         borderRadius: '6px',
// // //                                         cursor: 'pointer',
// // //                                         display: 'flex',
// // //                                         alignItems: 'center',
// // //                                         gap: isMobile ? '5px' : '8px',
// // //                                         fontSize: isMobile ? '13px' : '14px',
// // //                                         fontWeight: '600'
// // //                                     }}
// // //                                 >
// // //                                     <FaCheckCircle /> Mark All as Read
// // //                                 </button>

// // //                                 <button
// // //                                     onClick={clearAllNotifications}
// // //                                     style={{
// // //                                         backgroundColor: '#f44336',
// // //                                         color: 'white',
// // //                                         border: 'none',
// // //                                         padding: isMobile ? '8px 16px' : '10px 20px',
// // //                                         borderRadius: '6px',
// // //                                         cursor: 'pointer',
// // //                                         display: 'flex',
// // //                                         alignItems: 'center',
// // //                                         gap: isMobile ? '5px' : '8px',
// // //                                         fontSize: isMobile ? '13px' : '14px',
// // //                                         fontWeight: '600'
// // //                                     }}
// // //                                 >
// // //                                     <FaTrash /> Clear All
// // //                                 </button>
// // //                             </div>
// // //                         </div>

// // //                         {/* Filters and Search */}
// // //                         <div style={{
// // //                             backgroundColor: '#f8f9fa',
// // //                             padding: isMobile ? '15px' : '20px',
// // //                             borderRadius: '10px',
// // //                             marginBottom: '20px'
// // //                         }}>
// // //                             <div style={{
// // //                                 display: 'flex',
// // //                                 flexDirection: isMobile ? 'column' : 'row',
// // //                                 gap: '15px',
// // //                                 alignItems: isMobile ? 'stretch' : 'center'
// // //                             }}>
// // //                                 <div style={{
// // //                                     display: 'flex',
// // //                                     alignItems: 'center',
// // //                                     gap: '10px',
// // //                                     flexWrap: 'wrap',
// // //                                     justifyContent: isMobile ? 'center' : 'flex-start'
// // //                                 }}>
// // //                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// // //                                         <FaFilter style={{ color: '#666' }} />
// // //                                         <span style={{
// // //                                             fontSize: isMobile ? '13px' : '14px',
// // //                                             fontWeight: '600',
// // //                                             color: '#333'
// // //                                         }}>
// // //                                             Filter:
// // //                                         </span>
// // //                                     </div>
// // //                                     <div style={{
// // //                                         display: 'flex',
// // //                                         gap: '8px',
// // //                                         flexWrap: 'wrap',
// // //                                         justifyContent: isMobile ? 'center' : 'flex-start'
// // //                                     }}>
// // //                                         {notificationTypes.map(type => (
// // //                                             <button
// // //                                                 key={type.id}
// // //                                                 onClick={() => setFilterType(type.id)}
// // //                                                 style={{
// // //                                                     padding: isMobile ? '6px 12px' : '8px 16px',
// // //                                                     border: 'none',
// // //                                                     backgroundColor: filterType === type.id ? '#A055B0' : '#e0e0e0',
// // //                                                     color: filterType === type.id ? 'white' : '#333',
// // //                                                     borderRadius: '20px',
// // //                                                     cursor: 'pointer',
// // //                                                     fontSize: isMobile ? '12px' : '13px',
// // //                                                     fontWeight: '600',
// // //                                                     flexShrink: 0
// // //                                                 }}
// // //                                             >
// // //                                                 {type.label}
// // //                                             </button>
// // //                                         ))}
// // //                                     </div>
// // //                                 </div>

// // //                                 <div style={{
// // //                                     display: 'flex',
// // //                                     alignItems: 'center',
// // //                                     gap: '10px',
// // //                                     marginLeft: isMobile ? '0' : 'auto'
// // //                                 }}>
// // //                                     <button
// // //                                         onClick={() => setSortOrder(sortOrder === 'newest' ? 'oldest' : 'newest')}
// // //                                         style={{
// // //                                             padding: isMobile ? '6px 12px' : '8px 16px',
// // //                                             border: '1px solid #ddd',
// // //                                             backgroundColor: 'white',
// // //                                             color: '#333',
// // //                                             borderRadius: '6px',
// // //                                             cursor: 'pointer',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             gap: '6px',
// // //                                             fontSize: isMobile ? '12px' : '13px',
// // //                                             fontWeight: '600',
// // //                                             flexShrink: 0
// // //                                         }}
// // //                                     >
// // //                                         {sortOrder === 'newest' ? <FaSortAmountDown /> : <FaSortAmountUp />}
// // //                                         {sortOrder === 'newest' ? 'Newest' : 'Oldest'}
// // //                                     </button>

// // //                                     <div style={{
// // //                                         display: 'flex',
// // //                                         alignItems: 'center',
// // //                                         gap: '8px',
// // //                                         flex: isMobile ? 1 : 'none'
// // //                                     }}>
// // //                                         <FaSearch style={{ color: '#666' }} />
// // //                                         <input
// // //                                             type="text"
// // //                                             placeholder="Search notifications..."
// // //                                             value={searchQuery}
// // //                                             onChange={(e) => setSearchQuery(e.target.value)}
// // //                                             style={{
// // //                                                 padding: isMobile ? '8px 12px' : '10px 15px',
// // //                                                 border: '1px solid #ddd',
// // //                                                 borderRadius: '6px',
// // //                                                 fontSize: isMobile ? '13px' : '14px',
// // //                                                 width: '100%',
// // //                                                 minWidth: isMobile ? 'auto' : '200px',
// // //                                                 boxSizing: 'border-box'
// // //                                             }}
// // //                                         />
// // //                                     </div>
// // //                                 </div>
// // //                             </div>
// // //                         </div>

// // //                         {/* Notifications List */}
// // //                         <div style={{
// // //                             backgroundColor: '#fff',
// // //                             borderRadius: '10px',
// // //                             border: '1px solid #e0e0e0',
// // //                             overflow: 'hidden',
// // //                             minHeight: '300px',
// // //                             marginBottom: '20px',
// // //                             maxHeight: '500px',
// // //                             overflowY: 'auto',
// // //                             scrollBehavior: 'smooth'
// // //                         }}>
// // //                             {filteredNotifications.length === 0 ? (
// // //                                 <div style={{
// // //                                     padding: isMobile ? '40px 20px' : '60px 20px',
// // //                                     textAlign: 'center',
// // //                                     color: '#666'
// // //                                 }}>
// // //                                     <FaBell style={{
// // //                                         fontSize: isMobile ? '48px' : '64px',
// // //                                         marginBottom: '15px',
// // //                                         opacity: 0.3
// // //                                     }} />
// // //                                     <h4 style={{
// // //                                         margin: '0 0 10px 0',
// // //                                         color: '#333',
// // //                                         fontSize: isMobile ? '16px' : '18px'
// // //                                     }}>
// // //                                         No notifications found
// // //                                     </h4>
// // //                                     <p style={{
// // //                                         fontSize: isMobile ? '13px' : '14px',
// // //                                         margin: 0
// // //                                     }}>
// // //                                         Try adjusting your filters or search terms
// // //                                     </p>
// // //                                 </div>
// // //                             ) : (
// // //                                 filteredNotifications.map(notification => (
// // //                                     <div
// // //                                         key={notification.id}
// // //                                         style={{
// // //                                             padding: isMobile ? '12px 15px' : '15px 20px',
// // //                                             borderBottom: '1px solid #e0e0e0',
// // //                                             backgroundColor: notification.read ? '#fff' : '#f8f9fa',
// // //                                             display: 'flex',
// // //                                             alignItems: 'flex-start',
// // //                                             gap: isMobile ? '10px' : '15px',
// // //                                             position: 'relative'
// // //                                         }}
// // //                                     >
// // //                                         {/* Unread Indicator */}
// // //                                         {!notification.read && (
// // //                                             <div style={{
// // //                                                 position: 'absolute',
// // //                                                 left: '0',
// // //                                                 top: '0',
// // //                                                 bottom: '0',
// // //                                                 width: '4px',
// // //                                                 backgroundColor: getPriorityColor(notification.priority)
// // //                                             }}></div>
// // //                                         )}

// // //                                         {/* Notification Icon */}
// // //                                         <div style={{
// // //                                             width: isMobile ? '40px' : '50px',
// // //                                             height: isMobile ? '40px' : '50px',
// // //                                             borderRadius: '8px',
// // //                                             backgroundColor: getPriorityColor(notification.priority) + '20',
// // //                                             display: 'flex',
// // //                                             alignItems: 'center',
// // //                                             justifyContent: 'center',
// // //                                             color: getPriorityColor(notification.priority),
// // //                                             fontSize: isMobile ? '18px' : '22px',
// // //                                             flexShrink: 0
// // //                                         }}>
// // //                                             {getTypeIcon(notification.type)}
// // //                                         </div>

// // //                                         {/* Notification Content */}
// // //                                         <div style={{ flex: 1, minWidth: 0 }}>
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 flexDirection: isMobile ? 'column' : 'row',
// // //                                                 justifyContent: 'space-between',
// // //                                                 alignItems: isMobile ? 'flex-start' : 'flex-start',
// // //                                                 marginBottom: '8px',
// // //                                                 gap: isMobile ? '8px' : '0'
// // //                                             }}>
// // //                                                 <div style={{ flex: 1, minWidth: 0 }}>
// // //                                                     <div style={{
// // //                                                         display: 'flex',
// // //                                                         alignItems: 'center',
// // //                                                         gap: '8px',
// // //                                                         marginBottom: '5px',
// // //                                                         flexWrap: 'wrap'
// // //                                                     }}>
// // //                                                         <h4 style={{
// // //                                                             margin: 0,
// // //                                                             fontSize: isMobile ? '14px' : '16px',
// // //                                                             color: '#333',
// // //                                                             fontWeight: notification.read ? '600' : '700',
// // //                                                             wordBreak: 'break-word'
// // //                                                         }}>
// // //                                                             {notification.title}
// // //                                                         </h4>
// // //                                                         <span style={{
// // //                                                             fontSize: isMobile ? '10px' : '11px',
// // //                                                             color: 'white',
// // //                                                             backgroundColor: getPriorityColor(notification.priority),
// // //                                                             padding: '2px 8px',
// // //                                                             borderRadius: '10px',
// // //                                                             textTransform: 'uppercase',
// // //                                                             fontWeight: 'bold',
// // //                                                             flexShrink: 0
// // //                                                         }}>
// // //                                                             {notification.priority}
// // //                                                         </span>
// // //                                                     </div>
// // //                                                     <p style={{
// // //                                                         margin: '0 0 8px 0',
// // //                                                         fontSize: isMobile ? '13px' : '14px',
// // //                                                         color: '#666',
// // //                                                         lineHeight: '1.5',
// // //                                                         wordBreak: 'break-word'
// // //                                                     }}>
// // //                                                         {notification.message}
// // //                                                     </p>
// // //                                                 </div>

// // //                                                 <div style={{
// // //                                                     display: 'flex',
// // //                                                     flexDirection: 'column',
// // //                                                     gap: '6px',
// // //                                                     alignItems: isMobile ? 'flex-start' : 'flex-end',
// // //                                                     width: isMobile ? '100%' : 'auto'
// // //                                                 }}>
// // //                                                     <div style={{
// // //                                                         display: 'flex',
// // //                                                         alignItems: 'center',
// // //                                                         gap: '10px',
// // //                                                         flexWrap: 'wrap'
// // //                                                     }}>
// // //                                                         <span style={{
// // //                                                             fontSize: isMobile ? '11px' : '12px',
// // //                                                             color: '#999',
// // //                                                             display: 'flex',
// // //                                                             alignItems: 'center',
// // //                                                             gap: '5px',
// // //                                                             flexShrink: 0
// // //                                                         }}>
// // //                                                             <FaCalendarAlt /> {notification.timestamp}
// // //                                                         </span>

// // //                                                         <span style={{
// // //                                                             fontSize: isMobile ? '11px' : '12px',
// // //                                                             color: '#666',
// // //                                                             display: 'flex',
// // //                                                             alignItems: 'center',
// // //                                                             gap: '5px',
// // //                                                             flexShrink: 0
// // //                                                         }}>
// // //                                                             {getChannelIcon(notification.channel)}
// // //                                                             <span style={{ textTransform: 'capitalize' }}>
// // //                                                                 {notification.channel}
// // //                                                             </span>
// // //                                                         </span>
// // //                                                     </div>

// // //                                                     {/* Action Buttons */}
// // //                                                     <div style={{
// // //                                                         display: 'flex',
// // //                                                         gap: '8px',
// // //                                                         flexWrap: 'wrap'
// // //                                                     }}>
// // //                                                         {!notification.read && (
// // //                                                             <button
// // //                                                                 onClick={() => markAsRead(notification.id)}
// // //                                                                 style={{
// // //                                                                     backgroundColor: 'transparent',
// // //                                                                     color: '#2196F3',
// // //                                                                     border: '1px solid #2196F3',
// // //                                                                     padding: '4px 10px',
// // //                                                                     borderRadius: '4px',
// // //                                                                     cursor: 'pointer',
// // //                                                                     fontSize: isMobile ? '12px' : '13px',
// // //                                                                     display: 'flex',
// // //                                                                     alignItems: 'center',
// // //                                                                     gap: '5px',
// // //                                                                     flexShrink: 0
// // //                                                                 }}
// // //                                                             >
// // //                                                                 <FaCheckCircle /> Read
// // //                                                             </button>
// // //                                                         )}

// // //                                                         <button
// // //                                                             onClick={() => deleteNotification(notification.id)}
// // //                                                             style={{
// // //                                                                 backgroundColor: 'transparent',
// // //                                                                 color: '#f44336',
// // //                                                                 border: '1px solid #f44336',
// // //                                                                 padding: '4px 10px',
// // //                                                                 borderRadius: '4px',
// // //                                                                 cursor: 'pointer',
// // //                                                                 fontSize: isMobile ? '12px' : '13px',
// // //                                                                 display: 'flex',
// // //                                                                 alignItems: 'center',
// // //                                                                 gap: '5px',
// // //                                                                 flexShrink: 0
// // //                                                             }}
// // //                                                         >
// // //                                                             <FaTrash /> Delete
// // //                                                         </button>

// // //                                                         <button
// // //                                                             onClick={() => alert(`Viewing details for: ${notification.title}`)}
// // //                                                             style={{
// // //                                                                 backgroundColor: 'transparent',
// // //                                                                 color: '#4CAF50',
// // //                                                                 border: '1px solid #4CAF50',
// // //                                                                 padding: '4px 10px',
// // //                                                                 borderRadius: '4px',
// // //                                                                 cursor: 'pointer',
// // //                                                                 fontSize: isMobile ? '12px' : '13px',
// // //                                                                 display: 'flex',
// // //                                                                 alignItems: 'center',
// // //                                                                 gap: '5px',
// // //                                                                 flexShrink: 0
// // //                                                             }}
// // //                                                         >
// // //                                                             <FaEye /> Details
// // //                                                         </button>
// // //                                                     </div>
// // //                                                 </div>
// // //                                             </div>
// // //                                         </div>
// // //                                     </div>
// // //                                 ))
// // //                             )}
// // //                         </div>

// // //                         {/* Stats Summary */}
// // //                         <div style={{
// // //                             display: 'grid',
// // //                             gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
// // //                             gap: '15px'
// // //                         }}>
// // //                             <div style={{
// // //                                 backgroundColor: '#e8f5e9',
// // //                                 padding: isMobile ? '15px' : '20px',
// // //                                 borderRadius: '10px',
// // //                                 textAlign: 'center'
// // //                             }}>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '20px' : '28px',
// // //                                     fontWeight: 'bold',
// // //                                     color: '#2e7d32'
// // //                                 }}>
// // //                                     {notifications.length}
// // //                                 </div>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '12px' : '14px',
// // //                                     color: '#388e3c',
// // //                                     fontWeight: '600'
// // //                                 }}>
// // //                                     Total Notifications
// // //                                 </div>
// // //                             </div>

// // //                             <div style={{
// // //                                 backgroundColor: '#fff3e0',
// // //                                 padding: isMobile ? '15px' : '20px',
// // //                                 borderRadius: '10px',
// // //                                 textAlign: 'center'
// // //                             }}>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '20px' : '28px',
// // //                                     fontWeight: 'bold',
// // //                                     color: '#e65100'
// // //                                 }}>
// // //                                     {unreadCount}
// // //                                 </div>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '12px' : '14px',
// // //                                     color: '#ef6c00',
// // //                                     fontWeight: '600'
// // //                                 }}>
// // //                                     Unread
// // //                                 </div>
// // //                             </div>

// // //                             <div style={{
// // //                                 backgroundColor: '#e3f2fd',
// // //                                 padding: isMobile ? '15px' : '20px',
// // //                                 borderRadius: '10px',
// // //                                 textAlign: 'center'
// // //                             }}>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '20px' : '28px',
// // //                                     fontWeight: 'bold',
// // //                                     color: '#1565c0'
// // //                                 }}>
// // //                                     {notifications.filter(n => n.channel === 'sms').length}
// // //                                 </div>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '12px' : '14px',
// // //                                     color: '#1976d2',
// // //                                     fontWeight: '600'
// // //                                 }}>
// // //                                     SMS Notifications
// // //                                 </div>
// // //                             </div>

// // //                             <div style={{
// // //                                 backgroundColor: '#f3e5f5',
// // //                                 padding: isMobile ? '15px' : '20px',
// // //                                 borderRadius: '10px',
// // //                                 textAlign: 'center'
// // //                             }}>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '20px' : '28px',
// // //                                     fontWeight: 'bold',
// // //                                     color: '#7b1fa2'
// // //                                 }}>
// // //                                     {notifications.filter(n => n.type === 'stock').length}
// // //                                 </div>
// // //                                 <div style={{
// // //                                     fontSize: isMobile ? '12px' : '14px',
// // //                                     color: '#8e24aa',
// // //                                     fontWeight: '600'
// // //                                 }}>
// // //                                     Stock Alerts
// // //                                 </div>
// // //                             </div>
// // //                         </div>
// // //                     </div>
// // //                 )}
// // //             </div>
// // //         </div>
// // //     );
// // // }

// // // export default NotificationContext;


// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // // import SMSSettings from "./components/SMSSettings";
// // // import CustomAlerts from "./components/CustomAlerts";
// // // import NotificationHistory from "./components/NotificationHistory";
// // import SMSSettings from "../Component/Modules/FoodandBeverages/SMSSettings";
// // import CustomAlerts from "../Component/Modules/FoodandBeverages/CustomAlerts";
// // import NotificationHistory from "../Component/Modules/FoodandBeverages/NotificationHistory";

// // const NotificationContext = () => {
// //     const [activeTab, setActiveTab] = useState("SMS Settings");
// //     const isMobile = window.innerWidth <= 768;

// //     const tabContent = {
// //         "SMS Settings": <SMSSettings />,
// //         "Custom Alerts": <CustomAlerts />,
// //         "Notification History": <NotificationHistory />,
// //     };

// //     // Dynamic height based on screen size
// //     const containerHeight = window.innerHeight > 600
// //         ? (
// //             window.innerWidth < 768
// //                 ? '60vh'
// //                 : window.innerWidth < 850
// //                     ? '63vh'
// //                     : window.innerWidth < 1400
// //                         ? '65vh'
// //                         : window.innerWidth < 1600
// //                             ? '70vh'
// //                             : '75vh'
// //         )
// //         : (
// //             window.innerWidth < 768
// //                 ? '300px'
// //                 : window.innerWidth < 850
// //                     ? '300px'
// //                     : window.innerWidth < 1400
// //                         ? '410px'
// //                         : window.innerWidth < 1600
// //                             ? '410px'
// //                             : '450px'
// //         );

// //     return (
// //         <>
// //             <style>{`
// //             @media(max-width:399px){
// //             .tab-button{
// //             padding:10px;
// //             }
// //             }
// //                 .main-container {
// //                     padding: 20px;
// //                     display: flex;
// //                     flex-direction: column;
// //                 }

// //                 .tabs-wrapper {
// //                     display: flex;
// //                     flex-direction: column;
// //                     align-items: center;
// //                     gap: 10px;
// //                     margin-left: 0px;
// //                 }

// //                 @media screen and (max-width: 768px) {
// //                     .tabs-wrapper {
// //                         margin-left: 0;
// //                     }
// //                 }

// //                 @media screen and (min-width: 768px) {
// //                     .tabs-wrapper {
// //                         margin-top: 20px;
// //                     }
// //                 }

// //                 .tab-butttons {
// //                     display: flex;
// //                     justify-content: center;
// //                     gap: 10px;
// //                     margin-top: 81px;
// //                     padding: 14px;
// //                 }

// //                 .tab-button {
// //                     border: none;
// //                     border-radius: 10px;
// //                     width: auto;
// //                     min-width: 100px;
// //                     height: 40px;
// //                     background-color: #d9d9d9;
// //                     color: #000;
// //                     font-weight: 500;
// //                     cursor: pointer;
// //                     transition: background-color 0.3s ease;
// //                     font-size: 1rem;
// //                     white-space: nowrap;
// //                 }

// //                 .tab-button.active {
// //                     color: white;
// //                     background-color: #b15cd6;
// //                 }

// //                 .tab-content {
// //                     margin-top: 0px;
// //                     width: 100%;
// //                     overflow-x: auto;
// //                     overflow-y: scroll;
// //                 }

// //                 .tab-content::-webkit-scrollbar {
// //                     width: 1px;
// //                     height: 8px;
// //                 }

// //                 .tab-content::-webkit-scrollbar-track {
// //                     background: #f0f0f0;
// //                 }

// //                 .tab-content::-webkit-scrollbar-thumb {
// //                     background: #b15cd6;
// //                     border-radius: 10px;
// //                 }

// //                 .tab-content {
// //                     scrollbar-width: none;
// //                 }

// //                 .support-mobilescroll {
// //                     margin-top: 119px !important;
// //                 }

// //                 @media (min-width: 768px) {
// //                     .support-mobilescroll {
// //                         width: 62vw !important;
// //                         margin-left: -1vw !important;
// //                     }
// //                 }

// //                 @media (max-width: 500px) {
// //                     .tab-button {
// //                         font-size: 13px;
// //                     }
// //                 }

// //                 @media (max-width: 400px) {
// //                     .tab-button {
// //                         font-size: 12px;
// //                     }
// //                 }

// //                 @media (min-height:800px) {
// //                     .company-mobile-data {
// //                         height: 92vh !important;
// //                     }
// //                     .tab-content {
// //                         height: 70vh !important;
// //                     }
// //                 }

// //                 @media (min-height:600px) and (max-height:800px) {
// //                     .tab-content {
// //                         height: 65vh !important;
// //                     }
// //                 }

// //                 @media(min-height:500px) {
// //                     .container-fluid {
// //                         height: 100vh !important;
// //                     }
// //                 }

// //                 @media(max-height:500px) {
// //                     .container-fluid {
// //                         height: 70vh !important;
// //                     }
// //                 }
// //             `}</style>

// //             <div className="container-fluid company-mobile-data"
// //                 style={{
// //                     height: window.innerHeight < 500 ? "100vh" : "70vh",
// //                     backgroundColor: "white"
// //                 }}
// //             >
// //                 <div className="row" style={{ backgroundColor: "white" }}>
// //                     {/* Left Column - Empty */}
// //                     <div className="col-lg-2">
// //                         {/* Left section completely empty as requested */}
// //                     </div>

// //                     {/* Middle Column - Main Content */}
// //                     <div className="col-lg-10">
// //                         {/* Breadcrumb */}
// //                         <p
// //                             className="breadcrumb maamaas-home-bredcum"
// //                             style={{
// //                                 position: "fixed",
// //                                 top: window.innerWidth <= 500 ? "50px" : window.innerWidth > 500 && window.innerWidth <= 768 ? "55px" : "64px",
// //                                 left: "2vw",
// //                                 width: "100%",
// //                                 backgroundColor: "#fff",
// //                                 zIndex: 1000,
// //                                 padding: "10px 0",
// //                                 fontSize: isMobile ? "16px" : "18px",
// //                                 fontWeight: isMobile ? "normal" : "bold",
// //                                 textAlign: "center",
// //                                 margin: 0,
// //                             }}
// //                         >
// //                             <Link
// //                                 to="/foodladingpage"
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Food & Beverages
// //                             </Link>
// //                             <span className="separator"> &gt; </span>
// //                             <Link
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Notifications
// //                             </Link>
// //                         </p>

// //                         {/* Main Content Container */}
// //                         <div style={{
// //                             marginTop: window.innerWidth < 768 ? "0px" : "00px",
// //                             padding: isMobile ? "15px" : "20px",
// //                             backgroundColor: "#fff",
// //                             borderRadius: "10px",
// //                             width: window.innerWidth < 700 ? "94vw" : "auto",
// //                         }}>
// //                             {/* Tabs Wrapper */}
// //                             <div className="tabs-wrapper" style={{ marginTop: window.innerWidth < 500 ? "0px" : " " }}>
// //                                 {/* Tab Buttons */}
// //                                 <div className="tab-butttons" style={{
// //                                     flexWrap: window.innerWidth <= 380 ? "wrap" : "nowrap",
// //                                     marginTop: window.innerWidth < 769 ? "00px" : "50px",
// //                                     paddingLeft: window.innerWidth < 500 ? "0px" : " ",
// //                                     paddingRight: window.innerHeight < 500 ? "25px" : " ",
// //                                     marginRight: window.innerWidth < 769 ? " " : "20%"
// //                                 }}>
// //                                     {Object.keys(tabContent).map((label) => (
// //                                         <button
// //                                             key={label}
// //                                             className={`tab-button ${activeTab === label ? "active" : ""}`}
// //                                             onClick={() => setActiveTab(label)}
// //                                         >
// //                                             {label}
// //                                         </button>
// //                                     ))}
// //                                 </div>

// //                                 {/* Tab Content */}
// //                                 <div
// //                                     className="tab-content"
// //                                     style={{
// //                                         height: containerHeight,
// //                                         overflowX: "auto",
// //                                         overflowY: "scroll",
// //                                         width: window.innerWidth < 450 ? "83vw" : " ",
// //                                         padding: "10px",
// //                                         paddingLeft: window.innerWidth < 500 ? "0px" : " ",
// //                                         backgroundColor: "#fff",
// //                                         borderRadius: "8px",
// //                                     }}
// //                                 >
// //                                     {tabContent[activeTab]}
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </>
// //     );
// // };

// // export default NotificationContext;




// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import {
//     FaSms,
//     FaExclamationTriangle,
//     FaHistory,
//     FaBell
// } from "react-icons/fa";

// // Import the three tab components
// import SMSSettings from "../Component/Modules/FoodandBeverages/SMSSettings";
// import CustomAlerts from "../Component/Modules/FoodandBeverages/CustomAlerts";
// import NotificationHistory from "../Component/Modules/FoodandBeverages/NotificationHistory";

// function NotificationHub() {
//     // State for UI
//     const [activeTab, setActiveTab] = useState('smsSettings');
//     const [isMobile, setIsMobile] = useState(false);

//     // Check screen size
//     useEffect(() => {
//         const checkMobile = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };

//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     // Tabs configuration
//     const tabs = [
//         { id: 'smsSettings', label: 'SMS Settings', icon: <FaSms /> },
//         { id: 'alerts', label: 'Custom Alerts', icon: <FaExclamationTriangle /> },
//         { id: 'history', label: 'Notification History', icon: <FaHistory /> }
//     ];

//     return (
//         <div
//             style={{
//                 maxWidth: '1124px',
//                 margin: '107px auto',
//                 padding: isMobile ? '10px' : '20px',
//                 height: "75vh",
//                 width: "90vw",
//                 scrollbarWidth: "none",
//                 overflow: 'auto',
//                 fontFamily: 'Arial, sans-serif',
//                 overflowX: 'hidden',
//                 boxSizing: 'border-box',
//                 textAlign: 'center',
//             }}
//         >
//             {/* Breadcrumb */}
//             <p
//                 className="breadcrumb maamaas-home-bredcum"
//                 style={{
//                     position: "fixed",
//                     top: window.innerWidth <= 425 ? " 60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
//                     left: "2vw",
//                     width: "100%",
//                     backgroundColor: "#fff",
//                     zIndex: 1000,
//                     padding: "10px 0",
//                     fontSize: isMobile ? "16px" : "18px",
//                     fontWeight: isMobile ? "normal" : "bold",
//                     textAlign: "center",
//                     margin: 0,
//                 }}
//             >
//                 <Link
//                     to="/foodladingpage"
//                     style={{
//                         color: "purple",
//                         fontWeight: "bold",
//                         textDecoration: "none",
//                     }}
//                 >
//                     Food & Beverages
//                 </Link>
//                 <span className="separator"> &gt; </span>
//                 <Link
//                     style={{
//                         color: "purple",
//                         fontWeight: "bold",
//                         textDecoration: "none",
//                     }}
//                 >
//                     NotificationHub
//                 </Link>
//             </p>

//             {/* Tabs */}
//             <div style={{
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 justifyContent: 'center',
//                 gap: isMobile ? '5px' : '10px',
//                 marginBottom: '20px',
//                 backgroundColor: 'white',
//                 padding: isMobile ? '8px' : '10px',
//                 borderRadius: '10px',
//                 overflowX: isMobile ? 'auto' : 'visible',
//                 WebkitOverflowScrolling: 'touch',
//                 scrollbarWidth: 'none',
//                 msOverflowStyle: 'none'
//             }}>
//                 {tabs.map(tab => (
//                     <button
//                         key={tab.id}
//                         onClick={() => {
//                             setActiveTab(tab.id);
//                             // Smooth scroll to top on mobile
//                             if (isMobile) {
//                                 window.scrollTo({ top: 0, behavior: 'smooth' });
//                             }
//                         }}
//                         style={{
//                             padding: isMobile ? '8px 12px' : '12px 20px',
//                             border: 'none',
//                             backgroundColor: activeTab === tab.id ? '#A055B0' : '#f5f5f5',
//                             color: activeTab === tab.id ? 'white' : '#333',
//                             borderRadius: '8px',
//                             cursor: 'pointer',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: isMobile ? '6px' : '8px',
//                             fontSize: isMobile ? '12px' : '14px',
//                             fontWeight: '600',
//                             transition: 'all 0.3s ease',
//                             flexShrink: 0,
//                             whiteSpace: 'nowrap'
//                         }}
//                     >
//                         {tab.icon} {tab.label}
//                     </button>
//                 ))}
//             </div>

//             {/* Tab Content */}
//             <div style={{
//                 minHeight: '500px',
//                 overflow: 'visible'
//             }}>
//                 {/* Render the active tab component */}
//                 {activeTab === 'smsSettings' && <SMSSettings isMobile={isMobile} />}
//                 {activeTab === 'alerts' && <CustomAlerts isMobile={isMobile} />}
//                 {activeTab === 'history' && <NotificationHistory isMobile={isMobile} />}
//             </div>
//         </div>
//     );
// }

// export default NotificationHub;









import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    FaSms,
    FaExclamationTriangle,
    FaHistory,
    FaBell
} from "react-icons/fa";

// Import the three tab components
import SMSSettings from "../Component/Modules/FoodandBeverages/SMSSettings";
import CustomAlerts from "../Component/Modules/FoodandBeverages/CustomAlerts";
import NotificationHistory from "../Component/Modules/FoodandBeverages/NotificationHistory";

function NotificationHub() {
    // State for UI
    const [activeTab, setActiveTab] = useState('smsSettings');
    const [isMobile, setIsMobile] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
            setWindowWidth(window.innerWidth);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Tabs configuration
    const tabs = [
        { id: 'smsSettings', label: 'SMS Settings', icon: <FaSms /> },
        { id: 'alerts', label: 'Custom Alerts', icon: <FaExclamationTriangle /> },
        { id: 'history', label: 'Notification History', icon: <FaHistory /> }
    ];

    // Handle tab change
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        
        // Smooth scroll to top on mobile
        if (isMobile) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Render active tab component
    const renderActiveTab = () => {
        switch (activeTab) {
            case 'smsSettings':
                return <SMSSettings isMobile={isMobile} />;
            case 'alerts':
                return <CustomAlerts isMobile={isMobile} />;
            case 'history':
                return <NotificationHistory isMobile={isMobile} />;
            default:
                return <SMSSettings isMobile={isMobile} />;
        }
    };

    return (
        <div className="container-fluid" style={{
            fontFamily: 'Arial, sans-serif',
            overflowX: 'hidden',
            boxSizing: 'border-box',
            padding: 0,
            margin: 0,
            height: '100vh',
        }}>
        
            <p
                className="breadcrumb maamaas-home-bredcum"
                style={{
                    position: "fixed",
                    top: window.innerWidth <= 500 ? "50px" : window.innerWidth > 500 && window.innerWidth <= 768 ? "60px" : "64px",
                    left: "2vw",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    padding: "10px 0",
                    fontSize: isMobile ? "16px" : "18px",
                    fontWeight: isMobile ? "normal" : "bold",
                    textAlign: "center",
                    margin: 0,
                }}
            >
                 <Link
                    to="/foodladingpage"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Food & Beverages
                </Link>
                <span className="separator"> &gt; </span>
                <Link
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    NotificationHub
                </Link>
            </p>


            {/* Main Container */}
            <div className="row" style={{
                marginTop: windowWidth <= 425 ? "80px" : 
                           windowWidth > 425 && windowWidth <= 768 ? "84px" : 
                           "105px",
                marginLeft: 0,
                marginRight: 0,
                height: 'calc(100vh - 120px)',
                overflow: 'hidden'
            }}>
                
                {/* Empty 2 columns on left - Desktop only */}
                <div className="col-lg-2 d-none d-lg-block"></div>
                
                {/* Main Content Area - 8 columns */}
                <div className="col-lg-8" style={{
                    padding: isMobile ? '10px' : '20px',
                    overflowY: 'auto',
                    height: '100%',
                    scrollbarWidth: 'none',
                    paddingTop: isMobile ? '60px' : '80px' // Add padding for fixed tabs
                }}>
                    
                    {/* Fixed Tabs Container - Positioned above content */}
                    <div style={{
                        position: 'fixed',
                        top: windowWidth <= 425 ? '100px' : 
                             windowWidth > 425 && windowWidth <= 768 ? '104px' : 
                             '125px',
                        left: '0',
                        width: '100%',
                        zIndex: 999,
                        //backgroundColor: 'white',
                        padding: isMobile ? '5px 10px' : '10px 20px',
                        //boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        
                        {/* Mobile & Tablet Tabs */}
                        {isMobile && (
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                gap: '5px',
                                backgroundColor: 'white',
                                padding: '8px',
                                borderRadius: '10px',
                                overflowX: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none'
                            }}>
                                {tabs.map(tab => (
                                    <button
                                        key={tab.id}
                                        onClick={() => handleTabChange(tab.id)}
                                        style={{
                                            padding: '8px 12px',
                                            border: 'none',
                                            backgroundColor: activeTab === tab.id ? '#A055B0' : '#f5f5f5',
                                            color: activeTab === tab.id ? 'white' : '#333',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            transition: 'all 0.3s ease',
                                            flexShrink: 0,
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {tab.icon} {tab.label}
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Desktop Tabs */}
                        {!isMobile && (
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                gap: '10px',
                                marginTop: '-13px',
                                padding: '10px',
                                borderRadius: '10px',
                                overflowX: 'visible',
                                WebkitOverflowScrolling: 'touch',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                background: 'white'
                            }}>
                                {tabs.map(tab => (
                                    <button
                                        key={tab.id}
                                        onClick={() => handleTabChange(tab.id)}
                                        style={{
                                            padding: '12px 20px',
                                            border: 'none',
                                            backgroundColor: activeTab === tab.id ? '#A055B0' : '#f5f5f5',
                                            color: activeTab === tab.id ? 'white' : '#333',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            transition: 'all 0.3s ease',
                                            flexShrink: 0,
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {tab.icon} {tab.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Tab Content */}
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: isMobile ? '15px' : '25px',
                        minHeight: isMobile ? '400px' : 'calc(100vh - 250px)',
                        overflow: 'auto',
                        marginTop: isMobile ? '64px' : '10px'
                    }}>
                        {renderActiveTab()}
                    </div>
                </div>
                
                {/* Empty 2 columns on right - Desktop only */}
                <div className="col-lg-2 d-none d-lg-block"></div>
            </div>
        </div>
    );
}

export default NotificationHub;